import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Vuelidate from 'vuelidate'

import "@/plugins/lmc/lmc.umd"
import "@/plugins/lmc/lmc.css"
import "@/plugins/leiedal-map.umd.js"
import "@/plugins/leiedal-map.css"

Vue.use(Vuelidate)

Vue.config.productionTip = false
Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(fas)
Vue.use(VueSweetalert2)

export const Vm = new Vue({
  router,
  render: h => h(App),
}).$mount('#app')


